import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SwipeViews from "react-swipeable-views"
import React, { Fragment, useState, useContext } from "react"
import { AppContext } from "../Home/context"
import Calendar from "Components/Calendar"
import TabPanel from "./TabPanel"
import { PhotoCalendarTab } from "Types/app"
const tabArray: PhotoCalendarTab[] = [
    {
        value: "photo_board",
        text: "摄影日历",
        icon: <InsertInvitationIcon/>,
    }, {
        value: "photo_article_type",
        text: "文章类型",
        icon: <ListAltIcon/>,
    },
]
const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function PhotoCalendar() {
    const classes = useStyles()
    const [ index, setIndex ] = useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    const { privilegeMap, user } = useContext(AppContext)
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: PhotoCalendarTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: PhotoCalendarTab, index) => {
                        switch (tab.value) {
                            case 'photo_board':

                                return (
                                    <Fragment>
                                        <Calendar channelName={'摄影'}/>

                                        <Typography component="div">
                                            <pre style={{whiteSpace: 'pre-line'}}>
                                                预约规则：<br />
                                                1、今明两天不能删除已预约的点位；<br />
                                                2、预约说明请按 “预约人-拍摄需求-最晚交付的时间”的格式进行预约；<br />
                                                3、如果预约时间相撞了，请直接联系设计部主管白云飞；<br />
                                                4、如需要更改或者增加点位，也请联系设计部主管白云飞或者对接人大哥/大米。<br />
                                            </pre>
                                        </Typography>
                                    </Fragment>
                                )

                            default:
                                return (
                                    <TabPanel tab={tab} index={index} key={index} privilegeMap={privilegeMap}/>
                                )
                        }
                    })
                }
            </SwipeViews>
            <div id="board_input_modal" />
            <div id="photo_article_type_modal" />
        </div>
    )
}
